import React, { useEffect, useState } from "react";
import { Paper, Typography, Box, Chip } from "@material-ui/core";
import {
  validStageCallId,
  fetchMetaCallStageStatus
} from "../../services/metaCallStageControl";

// META_CALL_TICKET_STATUS_V1
// Solo consulta GET. No ejecuta acciones de llamada.

const labels = {
  ringing: "Llamada entrante - prueba",
  claimed: "Aceptacion simulada - audio no conectado",
  terminated: "Llamada finalizada"
};

const MetaCallTicketStageStatus = ({ ticketId, callId }) => {
  const valid = typeof callId === "string" &&
    validStageCallId(callId);

  const key = `${ticketId}:${callId}`;

  const [view, setView] = useState({
    key: "",
    result: null,
    error: ""
  });

  useEffect(() => {
    if (!valid) return undefined;

    let active = true;
    let inFlight = false;

    const refresh = async () => {
      if (!active || inFlight) return;

      inFlight = true;

      try {
        const result = await fetchMetaCallStageStatus(callId);

        if (!active) return;

        if (
          String(result.callId) !== String(callId) ||
          String(result.ticketId) !== String(ticketId)
        ) {
          setView({
            key,
            result: null,
            error: "La llamada no corresponde a esta conversacion."
          });
          return;
        }

        setView({ key, result, error: "" });
      } catch (_) {
        if (active) {
          setView({
            key,
            result: null,
            error: "Llamada no disponible o acceso no autorizado."
          });
        }
      } finally {
        inFlight = false;
      }
    };

    refresh();

    const timer = window.setInterval(refresh, 5000);

    return () => {
      active = false;
      window.clearInterval(timer);
    };
  }, [ticketId, callId, valid, key]);

  // META_CALL_INLINE_ALERT_V1
  const showInlineNotice =
    valid &&
    view.key === key &&
    view.result?.status === "ringing";

  useEffect(() => {
    const notify = () => {
      window.dispatchEvent(
        new Event("manda-meta-call-inline-target-changed")
      );
    };

    notify();
    return notify;
  }, [showInlineNotice, callId, ticketId]);
  if (!valid) return null;

  const current = view.key === key;
  const result = current ? view.result : null;
  const error = current ? view.error : "";

  return (
    <Paper
      variant="outlined"
      style={{
        padding: 14,
        marginTop: 14,
        marginBottom: 14,
        borderLeft: "4px solid #228b5b",
        borderRadius: 8
      }}
    >
      <Typography variant="subtitle1">
        Estado de llamada - staging
      </Typography>

      <Box mt={1} mb={1}>
        <Typography variant="body2">
          Conversacion #{ticketId}
        </Typography>
      </Box>

      {!current && (
        <Typography variant="body2">
          Consultando estado autorizado...
        </Typography>
      )}

      {error && (
        <Typography variant="body2" color="error">
          {error}
        </Typography>
      )}

      {result && (
        <Chip
          size="small"
          variant="outlined"
          label={labels[result.status] || "Estado no disponible"}
        />
      )}

      {showInlineNotice && (
        <div
          id="manda-meta-call-inline-anchor"
          data-meta-call-id={callId}
          data-ticket-id={String(ticketId)}
          style={{ marginTop: 12 }}
        />
      )}
      <Box mt={1}>
        <Typography variant="caption" color="textSecondary">
          Consulta protegida por el backend.
          No hay audio real conectado.
          Contestar y rechazar permanecen en el aviso original.
        </Typography>
      </Box>
    </Paper>
  );
};

export default MetaCallTicketStageStatus;